<Page name="recommendation" class="recommendation-detail-wrapper" id="print-this-page">
    {#if oRecommendation}
      <!-- Top Navbar -->
      <Navbar title={`${oRecommendation.title} [${oRecommendation.grade}]`} backLink="Back" backLinkUrl="/" />
      <div style="position: fixed;
      right: 20px;
      bottom: 0px;
      background-color: white;
      z-index: 20;
      border-radius: 2px;">
        <Button style="float:left"
        onClick={() => sendEmail()}><i class="icon f7-icons">envelope</i></Button>
        <Button 
        onClick={() => printDiv('print-this-page')}><i class="icon f7-icons">printer</i></Button>
      </div>
      <!-- Page content -->
      <Block style="margin-bottom:0;">
        {#if isMobile }
          <Button class="wv-btn" tabLink="#general" tabLinkActive>General</Button>
          <Button class="wv-btn" tabLink="#rationale">{isPubDateNext ? "Assessment" : "Rationale" }</Button>
          <Button class="wv-btn" tabLink="#clinical">{isPubDateNext ? "Practice" : "Clinical" }</Button>
          <Button class="wv-btn" tabLink="#others">Others</Button>
          <Button class="wv-btn" tabLink="#tools">Tools</Button>
        {:else}
          <Segmented strong tag="p">
            <Button class="wv-btn" tabLink="#general" tabLinkActive>General</Button>
            <Button class="wv-btn" tabLink="#rationale">{isPubDateNext ? "Assessment" : "Rationale" }</Button>
            <Button class="wv-btn" tabLink="#clinical">{isPubDateNext ? "Practice" : "Clinical" }</Button>
            <Button class="wv-btn" tabLink="#others">Others</Button>
            <Button class="wv-btn" tabLink="#tools">Tools</Button>
          </Segmented>
        {/if}
      </Block>
      <Tabs>
        <Tab id="general" tabActive class="">
          <div class="tab-content">
            <Block>
              <Card class="overflow">
                <CardHeader><span class="card-header-text">Specific Recommendations</span></CardHeader>
                <CardContent class="overflow">
                  {#if oRecommendation.text}
                    {@html fParseHTMLString(oRecommendation.text)} 
                  {:else}
                    <p class="alert-error-text">No Specific Recommendation information currently available.</p>
                  {/if} 
                </CardContent>
              </Card>
              {#if generalRec && generalRec.pathwayToBenefit}
                <Card class="overflow">
                  <CardHeader><span class="card-header-text">Pathway to Benefit</span></CardHeader>
                  <CardContent class="overflow">
                    {@html fParseHTMLString((generalRec && generalRec.pathwayToBenefit))}
                  </CardContent>
                </Card>
              {/if}
              <Card class="overflow">
                <CardHeader><span class="card-header-text">Frequency of Service</span></CardHeader>
                <CardContent class="overflow">
                {#if oRecommendation.servFreq}
                  {@html fParseHTMLString(oRecommendation.servFreq)}  
                  {:else}
                    <p class="alert-error-text">No Frequency of Service information currently available.</p>
                  {/if} 
                </CardContent>
              </Card>
              <Card class="overflow">
                <CardHeader><span class="card-header-text">Risk Factor Information</span></CardHeader>
                <CardContent class="overflow">
                  {#if oRecommendation.riskText}
                  {@html fParseHTMLString(oRecommendation.riskText)}  
                  {:else}
                    <p class="alert-error-text">No Risk Factor Information currently available.</p>
                  {/if}  
                </CardContent>
              </Card>
              <p><Link style="padding-left:10px;" href={"https://www.uspreventiveservicestaskforce.org/uspstf/document/RecommendationStatementFinal/"+generalRec.uspstfAlias} external target="_blank">View full recommendation click here</Link></p>
            </Block>
          </div>
        </Tab>
        <Tab id="rationale" class="">
          <div class="tab-content">
            <Block>
                <Card class="overflow">
                    <CardContent class="overflow"> 
                      {@html fParseHTMLString((generalRec && generalRec.rationale) || (oRecommendation && oRecommendation.rationale))}
                    </CardContent>
                </Card>
                <p><Link style="padding-left:10px;" href={"https://www.uspreventiveservicestaskforce.org/uspstf/document/RecommendationStatementFinal/"+generalRec.uspstfAlias} external target="_blank">View full recommendation click here</Link></p>
            </Block>
          </div>
        </Tab>
        <Tab id="clinical" class="">
          <div class="tab-content">
            <Block>
            {#if generalRec && generalRec.clinical}
                <Card class="overflow">
                    <CardContent class="overflow">
                      {@html fParseHTMLString(generalRec && generalRec.clinical)}
                    </CardContent>
                    {#if generalRec.clinicalUrl}
                    <CardFooter>
                      <Link href={generalRec.clinicalUrl} external target="_blank">{generalRec.clinicalUrl}</Link>
                    </CardFooter>
                    {/if}
                </Card>
            {/if}
            <p><Link style="padding-left:10px;" href={"https://www.uspreventiveservicestaskforce.org/uspstf/document/RecommendationStatementFinal/"+generalRec.uspstfAlias} external target="_blank">View full recommendation click here</Link></p>
            </Block>
          </div>
        </Tab>
        <Tab id="others" class="">
          <div class="tab-content">
          <Block>
            <Card class="overflow">
                <CardContent class="overflow">
                {#if generalRec && generalRec.discussion}
                  {@html fParseHTMLString(generalRec.discussion)}
                {:else}
                  <p class="alert-error-text">No Discussion Information currently available.</p>
                {/if}
                </CardContent>
            </Card>
          </Block>
          <Block>
            <Card class="overflow">
                <CardContent class="overflow">
                {#if generalRec && generalRec.other}
                  {@html fParseHTMLString(generalRec.other)}
                {:else}
                  <p class="alert-error-text">No Other Sections Information currently available.</p>
                {/if}
                </CardContent>
            </Card>
            <p><Link style="padding-left:10px;" href={"https://www.uspreventiveservicestaskforce.org/uspstf/document/RecommendationStatementFinal/"+generalRec.uspstfAlias} external target="_blank">View full recommendation click here</Link></p>
          </Block>
          </div>
        </Tab>
        <Tab id="tools">
          <div class="tab-content">
          <Block>
            <Card class="overflow">
                <CardHeader><span class="card-header-text">Tools</span></CardHeader>
                <CardContent class="overflow">
                  {#if oRecommendation && oRecommendation.toolData && oRecommendation.toolData.length > 0}
                  <ul>
                    {#each oRecommendation.toolData as tool, i}
                      <li>
                        <Link href={tool.url} external target="_blank">{tool.title}</Link>
                      </li>
                    {/each}
                  </ul>
                  {:else}
                  <p class="alert-error-text">No Tools information currently available.</p>
                  {/if}
                </CardContent>
            </Card>  
            <p><Link style="padding-left:10px;" href={"https://www.uspreventiveservicestaskforce.org/uspstf/document/RecommendationStatementFinal/"+generalRec.uspstfAlias} external target="_blank">View full recommendation click here</Link></p>
          </Block>
          </div>
        </Tab>
      </Tabs>
    {:else}
      <div class="preloader-modal" style="background: transparent;">
        <Preloader size={70} color="blue"></Preloader>
      </div>
    {/if}
</Page>
<script>
  /*TO-DO: Clean up code*/
  import {
      Page,
      Navbar,
      Link,
      Block,
      BlockHeader,
      Preloader,
      Subnavbar,
      Segmented,
      Button,
      Tabs,
      Tab,
      Card,
      CardHeader,
      CardContent,
      CardFooter,
      Row
  } from 'framework7-svelte';
  import { fParseHTMLString } from '../utils';
  import { getContext, onDestroy, onMount, afterUpdate, tick } from 'svelte';
  import { searchData } from '../stores.js';
  import Footer from '../components/Footer.svelte';
  export let recommendation;

  // Router component will receive f7router prop with current Router instance
  export let f7router;
  // Router component will receive f7route prop with current route data
  export let f7route;

  let id = recommendation && recommendation.id;
  let oRecommendation;
  let recommendations;
  let generalRec;
  let data = {};
  let unsubscribe;
  let toolArr = [];
  let isMobile = true;
  let isPubDateNext = false;
  let currentURL = window.location.href;

  let unsubscribeSearchData;

  $: getSearchData();
  $: fResize();

  onMount(() => {
    id = f7route && f7route.params && f7route.params.id;
    unsubscribeSearchData = searchData.subscribe(obj => {
      if (obj) {
        getSearchData(obj);
      }
    });
  });

  onMount(async () => {
    await tick();
  });
  
  afterUpdate(async () => {
    await tick();
  });

  function fResize() {
    if (window.innerWidth > 850) {
      isMobile = false;
    } else {
      isMobile = true;
    }
  }

  window.addEventListener("resize", fResize);

  // ('a').forEach(function (e) { $$(e).addClass('external'); });
  // onDestroy(() => {
  //         console.log("Destroyed");
  //     });

  // onDestroy(unsubscribeSearchData);

  async function getSearchData(searchData) {
    if (!searchData) { return; }
    const data = searchData;
    recommendations = data.specificRecommendations;
    recommendations = recommendations.filter(rec => Number(rec.id) === Number(id));
    if (!recommendations || recommendations.length < 1) { return; }
    oRecommendation = recommendations[0];
    oRecommendation && oRecommendation.tool && oRecommendation.tool.map(id => {
      if (data.tools && data.tools[id]) toolArr.push(data.tools[id]);
    });
    oRecommendation.toolData = toolArr;

    const genRecs = data && data.generalRecommendations;
    generalRec = genRecs[oRecommendation && oRecommendation.general];

    // pub date
    if (oRecommendation && oRecommendation.generalRecommendation && oRecommendation.generalRecommendation.pubDate) {
      const pubDateParsed = new Date(oRecommendation.generalRecommendation.pubDate);
      const compareDt = new Date("2019-09-04");
      if (pubDateParsed.getTime() > compareDt.getTime()) {
        isPubDateNext = true;
      }
    } else {
      if (parseInt(oRecommendation.general) > 213) {
        isPubDateNext = true;
      }
    }
  }

  function printDiv(divName) {
    document.getElementById(divName).classList.add("section-to-print-body");
    window.print();
    document.getElementById(divName).classList.remove("section-to-print-body");
  }

  function sendEmail() {
    const currentURL = window.location.href;
    window.location=`mailto:?subject=Prevention TaskForce Recommendations Rx&body=Please check out this recommendation: ${currentURL}`
  }
  
  function goBack() {
    const URL = window.location.origin;
    // if (!document.referrer.includes(window.location.host)) {
    //   window.location.href = URL;
    // }
  }
</script>
<style>
:global(.view-master-detail .navbar-master-detail-root .link.back, .view-master-detail .page-master-detail-root .navbar .link.back) {
  display: none;
}
.card-header-text {
  font-weight: bold;
}
</style>